import Logo from "images/logos/tonatrenujes.svg";
import { useTranslation } from "react-i18next";

import { Button, Image } from "react-bootstrap";

const NotAuthenticated = () => {
  const { t } = useTranslation("auth");

  return (
    <div className="fullpage bg-primary-subtle">
      <div className="text-center px-3 mw-sm">
        <div className="mb-40px">
          <Logo />
        </div>

        <Image src="/images/capy-paused.svg" alt="" className="mb-20px" />

        <h1 className="h2">{t("heading")}</h1>
        <p>{t("info")}</p>
        <p>{t("loginHint")}</p>

        <Button className="w-100" href="https://zona.to-das.cz/">
          {t("loginButton")}
        </Button>
      </div>
    </div>
  );
};

export default NotAuthenticated;
